import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Typography } from '@mui/material';
import { FONT_SIZE_39_PX, FONT_SIZE_49_PX, FONT_SIZE_61_PX, FONT_WEIGHT_NORMAL } from 'popTheme';

const Header = () => {
  const style = useStyle();
  const copy = useCopy();

  return (
    <>
      <Typography variant="h1" sx={style.title}>
        {copy.title}
      </Typography>
      <Typography variant="body2" sx={style.blurb}>
        {copy.blurb}
      </Typography>
    </>
  );
};
export default Header;

const useStyle = () => {
  const title = {
    color: 'text.primary',
    fontSize: { xs: FONT_SIZE_39_PX, sm: FONT_SIZE_49_PX, md: FONT_SIZE_61_PX },
  };
  const blurb = {
    color: 'text.primary',
    fontWeight: FONT_WEIGHT_NORMAL,
    fontSize: '1.25rem',
    marginTop: '2.5rem',
    maxWidth: '64rem',
    lineHeight: '175%',
  };

  return { title, blurb };
};

const useCopy = () => {
  const copy = defineMessages({
    checkInTitle: {
      id: 'checkIn.title',
      defaultMessage: 'Check In',
      description: 'Check in page title text',
    },
    checkInBlurb: {
      id: 'checkIn.blurb',
      defaultMessage:
        'There are many things inside and outside the body that can change the way your body processes pain. Complete a self-assessment today to track your progress and tailor resources based on where you may need extra support.',
      description: 'CheckIn page blurb',
    },
  });

  const intl = useIntl();
  const title = intl.formatMessage(copy.checkInTitle);
  const blurb = intl.formatMessage(copy.checkInBlurb);

  return { title, blurb };
};
